import { render, staticRenderFns } from "./WhatsappPollView.vue?vue&type=template&id=2f9c113e"
import script from "./WhatsappPollView.vue?vue&type=script&lang=js"
export * from "./WhatsappPollView.vue?vue&type=script&lang=js"
import style0 from "./WhatsappPollView.vue?vue&type=style&index=0&id=2f9c113e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports